import {h, Component} from 'preact';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import {mapRootUrl} from '@util/URLUtils';

import Menu from '../Menu';

class NavMenus extends Component {
    renderMenu = function renderMobileNavMenu ( acc, node ) {
        const {sysId, children} = node;

        if ( !isEmptyOrNil( children ) ) {
            acc.push( <Menu key={sysId} {...node} /> );

            children
                .map( mapRootUrl( node ) )
                .forEach( child => {
                    if ( !isEmptyOrNil( child.children ) ) {
                        [child].reduce( renderMobileNavMenu, acc );
                    }
                } );
        }

        return acc;
    };

    renderMenuList = function renderMobileTaxonomy ( taxonomy ) {
        const nodeList = [];

        taxonomy.forEach( node => {
            const {children} = node;

            if ( isEmptyOrNil( children ) ) {
                return null;
            }

            children
                .map( mapRootUrl( node ) )
                .reduce( this.renderMenu, nodeList );
        } );

        return nodeList;
    };

    render ( {taxonomy} ) {
        return (
            <div>{this.renderMenuList( taxonomy )}</div>
        );
    }
}

export default NavMenus;